import * as HttpService from './http.service';

import { GET_FEATURE_FLAGS_URL } from './url.service';

export function featureFlagService() {
    return {
        /**
         * Fetch feature flags from the backend
         * @returns {Promise<Array>} List of feature flags
         */
        async fetchFeatureFlags() {
            try {
                const response = await HttpService.getWithOutAuth(GET_FEATURE_FLAGS_URL);
                return response.entity || [];
            } catch (error) {
                console.error('Failed to fetch feature flags:', error);
                // Return an empty array as fallback
                return [];
            }
        },

        /**
         * Check if a specific feature flag is enabled
         * @param {string} flagName - Name of the feature flag
         * @returns {boolean} Whether the feature flag is enabled
         */
        isFeatureEnabled(flagName) {
            // Guard for server-side rendering (Next.js) where `window`/`sessionStorage` are not available
            if (typeof window === 'undefined' || !window.sessionStorage) return false;

            const storedFlags = window.sessionStorage.getItem('featureFlags');
            if (!storedFlags) return false;

            try {
                const { featureFlags } = JSON.parse(storedFlags);
                const flag = featureFlags.find(f => f.name === flagName);
                return flag ? flag.isEnabled : false;
            } catch (error) {
                console.error('Error parsing feature flags:', error);
                return false;
            }
        }
    };
}

// Export default service instance
export default featureFlagService();